import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import RepVisitsOverview from './overview';
import { getOrdinalDate } from '../RepVisitsSearchPage/date-utils';

const query = gql`
  query RepVisitsOverview($fromDate: OrdinalDate!, $toDate: OrdinalDate!, $userBookingStatus: RSVPStatus) {
    viewer {
      id
      enabledFeatures
      repVisitsEvents(fromDate: $fromDate, toDate: $toDate, userBookingStatus: $userBookingStatus) {
          id
          dayId
          appointmentId
          collegeFairId
          date
          startTime
          endTime
          timezone
          chosenVisitLocationType
          highSchool {
            name
            id
            address {
              field_hs_elna_city
              field_hs_elna_state_latest
            }
            repVisitsAccount {
              id
              primaryContactPhone
              primaryContact {
                id
                name
                communityId
                field_user_institution
                field_job_position
                field_contact_work
              }
              collegeFairsPrimaryContact {
                id
                name
                communityId
                field_user_institution
                field_job_position
                field_contact_work
              }
              collegeFairsPrimaryContactPhone
            }
          }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: () => {
    const dateFrom = getOrdinalDate(new Date());
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 6);

    return {
      variables: {
        fromDate: dateFrom,
        toDate: getOrdinalDate(nextWeek),
        userBookingStatus: 'APPROVED',
      },
      fetchPolicy: 'cache-and-network',
    };
  },
});

export default SimpleGraphQLComponent(graphqlData)(RepVisitsOverview);
